import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalNatureReadAction from './legalNatureRead.action.json' assert { type: 'json' }

const legalNatureReadDefinition = defineReadAutoAction(legalNatureReadAction, 'legalNature')

export default legalNatureReadDefinition
